import React from 'react';
import { Link } from 'react-router-dom'; 
import LoginForm from '../auth/LoginForm';
import { useAuth } from '../auth/AuthContext';

const LoginPage = () => {
  const { login } = useAuth();

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Prijava</h2>
        <LoginForm onLogin={login} />
        <p style={styles.registerLink}>
          Nemate račun? <Link to="/registracija">Registrirajte se</Link>
        </p>
      </div>
    </div>
  );
};


const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '80vh',
    padding: '1rem',
    backgroundColor: '#f8f9fa'
  },
  card: {
    width: '100%',
    maxWidth: '450px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
    padding: '2rem'
  },
  title: {
    textAlign: 'center',
    marginBottom: '1.5rem',
    color: '#2c3e50'
  },
  registerLink: {
    textAlign: 'center',
    marginTop: '1.5rem',
    color: '#666'
  }
};

export default LoginPage;